(() => {
  const prices = /€[ \u00a0\u202f]*((?:\d{1,3}(?:,\d{3})+|\d+)\.\d{2}|(?:\d{1,3}(?:[. \u00a0\u202f]\d{3})+|\d+),\d{2})(?!\d)|(?<![\d.,])((?:\d{1,3}(?:,\d{3})+|\d+)\.\d{2})[ \u00a0\u202f]*€/g;
  const format = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const excluded = 'script, style, textarea, template, noscript, code, pre, [contenteditable]';

  function normalize(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const updated = node.data.replace(prices, (_, prefix, suffix) => {
      const amount = prefix || suffix;
      const normalized = amount.at(-3) === ','
        ? amount.replace(/[. \u00a0\u202f]/g, '').replace(',', '.')
        : amount.replace(/,/g, '');
      return format.format(Number(normalized)) + '\u00a0€';
    });
    if (updated !== node.data) node.data = updated;
  }

  function visit(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      normalize(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) normalize(walker.currentNode);
  }

  visit(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') normalize(record.target);
      else for (const node of record.addedNodes) visit(node);
    }
  }).observe(document.body, { subtree: true, childList: true, characterData: true });
})();